import { spItemKeyFacet } from '../../../dataSource/Keys';
import { itemIsReadOnlyControl } from '@ms/items-view/lib/private/controls/itemIsReadOnlyControl';
import { IControlHandler, createControlHandler } from '@ms/items-view/lib/private/addons/registerControlHandler';
import { IItemCacheThunkAction } from '@ms/items-view/lib/private/store/actions/ItemCacheActions';
import { IItemCacheDispatch } from '@ms/items-view/lib/private/store/actions/ItemCacheActions';
import { IItemCache } from '@ms/items-view/lib/private/models/IItemCacheObserver';
import { permissionsFacet } from '../../../dataSource/Facets';
import PermissionMask from '@ms/odsp-datasources/lib/utilities/permissions/PermissionMask';
import { getPageContextFromItemCache } from '../../../utilities/item/pageContextHelper';

export const spItemIsReadOnlyControlHandler:
  IControlHandler<typeof spItemKeyFacet.type, typeof itemIsReadOnlyControl.type> =
  createControlHandler()(getSpItemIsReadonlyControlHandler);

function getSpItemIsReadonlyControlHandler(): IItemCacheThunkAction<typeof itemIsReadOnlyControl.type> {
  return (dispatch: IItemCacheDispatch) => {
    return (
      itemCache: IItemCache,
      props: typeof itemIsReadOnlyControl.inputType
    ): typeof itemIsReadOnlyControl.returnType => {
      const pageContext = getPageContextFromItemCache(itemCache, props.itemKey);

      if (pageContext && pageContext.isAnonymousGuestUser) {
        return {
          isReadOnly: true
        };
      }

      const permissions = itemCache.demandItemFacet(permissionsFacet, props.itemKey);

      const isReadonly =
        // Must ensure there is a permission mask, or else the results cannot be definitive.
        !!permissions &&
        !PermissionMask.hasItemPermission({ permissions: permissions }, PermissionMask.editListItems);

      if (isReadonly) {
        return {
          isReadOnly: true
        };
      }

      return {};
    };
  };
}
